module.exports = __webpack_public_path__ + "static/media/publicsector3.f9b9bddf.png";